import angular from 'angular';
import '../../shared.module';
import template from './modal.component.html';
import './modal.component.scss';

class ModalController {
  constructor($document, $scope) {
    this.$document = $document;
    this.$scope = $scope;
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  $onInit() {
    this.$document.on('keydown', this.handleKeydown);
  }

  $onDestroy() {
    this.$document.off('keydown', this.handleKeydown);
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.isOpen) {
      this.$scope.$applyAsync(() => this.close());
    }
  }

  close() {
    if (this.onClose) this.onClose();
  }
}

ModalController.$inject = ['$document', '$scope'];

angular.module('app.shared').component('cpModal', {
  bindings: {
    isOpen: '<',
    title: '@',
    size: '@',
    onClose: '&'
  },
  transclude: true,
  controller: ModalController,
  controllerAs: 'vm',
  template
});
